module.exports = __webpack_public_path__ + "media/images/refresh-58b172c547e32e2adfeff8e471b28b98.svg";